import React from 'react'
import './style.scss'

const Textbtn = ({ text, onClick, color, disabled }) => {
    return (
        <button className='text__btn__main' disabled={disabled} style={color ? {color}:{}} onClick={onClick}>
            {text}
        </button>
    )
}

export default Textbtn